module.exports = __webpack_public_path__ + "static/other/gameCityBuilder.2cb5a787.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameCityBuilder.json
// module id = 2653
// module chunks = 0